var cov_1oajzq6r1v = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/value.tsx",
      hash = "e2249f65ccdd71e95d310d3e44f73933c7d5ce3c",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/value.tsx",
    statementMap: {
      "0": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 145,
          column: 3
        }
      },
      "1": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 20,
          column: 18
        }
      },
      "2": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 41
        }
      },
      "3": {
        start: {
          line: 23,
          column: 6
        },
        end: {
          line: 23,
          column: 50
        }
      },
      "4": {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 24,
          column: 54
        }
      },
      "5": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 60
        }
      },
      "6": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 41
        }
      },
      "7": {
        start: {
          line: 33,
          column: 22
        },
        end: {
          line: 33,
          column: 65
        }
      },
      "8": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 108
        }
      },
      "9": {
        start: {
          line: 38,
          column: 24
        },
        end: {
          line: 38,
          column: 34
        }
      },
      "10": {
        start: {
          line: 39,
          column: 6
        },
        end: {
          line: 41,
          column: 7
        }
      },
      "11": {
        start: {
          line: 40,
          column: 8
        },
        end: {
          line: 40,
          column: 32
        }
      },
      "12": {
        start: {
          line: 45,
          column: 27
        },
        end: {
          line: 45,
          column: 37
        }
      },
      "13": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 65
        }
      },
      "14": {
        start: {
          line: 50,
          column: 31
        },
        end: {
          line: 50,
          column: 41
        }
      },
      "15": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 31
        }
      },
      "16": {
        start: {
          line: 51,
          column: 18
        },
        end: {
          line: 51,
          column: 31
        }
      },
      "17": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 63,
          column: 7
        }
      },
      "18": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 38
        }
      },
      "19": {
        start: {
          line: 56,
          column: 10
        },
        end: {
          line: 56,
          column: 26
        }
      },
      "20": {
        start: {
          line: 58,
          column: 10
        },
        end: {
          line: 58,
          column: 27
        }
      },
      "21": {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 60,
          column: 26
        }
      },
      "22": {
        start: {
          line: 62,
          column: 10
        },
        end: {
          line: 62,
          column: 29
        }
      },
      "23": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 41
        }
      },
      "24": {
        start: {
          line: 67,
          column: 29
        },
        end: {
          line: 67,
          column: 41
        }
      },
      "25": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 73,
          column: 7
        }
      },
      "26": {
        start: {
          line: 72,
          column: 37
        },
        end: {
          line: 72,
          column: 38
        }
      },
      "27": {
        start: {
          line: 77,
          column: 34
        },
        end: {
          line: 77,
          column: 44
        }
      },
      "28": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      "29": {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 79,
          column: 32
        }
      },
      "30": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 24
        }
      },
      "31": {
        start: {
          line: 82,
          column: 21
        },
        end: {
          line: 82,
          column: 37
        }
      },
      "32": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 93,
          column: 7
        }
      },
      "33": {
        start: {
          line: 85,
          column: 25
        },
        end: {
          line: 89,
          column: 9
        }
      },
      "34": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 91,
          column: 82
        }
      },
      "35": {
        start: {
          line: 90,
          column: 44
        },
        end: {
          line: 90,
          column: 62
        }
      },
      "36": {
        start: {
          line: 91,
          column: 13
        },
        end: {
          line: 91,
          column: 82
        }
      },
      "37": {
        start: {
          line: 91,
          column: 48
        },
        end: {
          line: 91,
          column: 82
        }
      },
      "38": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 23
        }
      },
      "39": {
        start: {
          line: 96,
          column: 30
        },
        end: {
          line: 96,
          column: 40
        }
      },
      "40": {
        start: {
          line: 97,
          column: 31
        },
        end: {
          line: 104,
          column: 8
        }
      },
      "41": {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 32
        }
      },
      "42": {
        start: {
          line: 98,
          column: 16
        },
        end: {
          line: 98,
          column: 32
        }
      },
      "43": {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 103,
          column: 9
        }
      },
      "44": {
        start: {
          line: 106,
          column: 6
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "45": {
        start: {
          line: 107,
          column: 8
        },
        end: {
          line: 107,
          column: 53
        }
      },
      "46": {
        start: {
          line: 107,
          column: 22
        },
        end: {
          line: 107,
          column: 53
        }
      },
      "47": {
        start: {
          line: 108,
          column: 13
        },
        end: {
          line: 112,
          column: 7
        }
      },
      "48": {
        start: {
          line: 110,
          column: 8
        },
        end: {
          line: 110,
          column: 61
        }
      },
      "49": {
        start: {
          line: 111,
          column: 8
        },
        end: {
          line: 111,
          column: 23
        }
      },
      "50": {
        start: {
          line: 114,
          column: 6
        },
        end: {
          line: 119,
          column: 7
        }
      },
      "51": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 61
        }
      },
      "52": {
        start: {
          line: 118,
          column: 8
        },
        end: {
          line: 118,
          column: 35
        }
      },
      "53": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 21
        }
      },
      "54": {
        start: {
          line: 125,
          column: 24
        },
        end: {
          line: 125,
          column: 34
        }
      },
      "55": {
        start: {
          line: 126,
          column: 86
        },
        end: {
          line: 126,
          column: 95
        }
      },
      "56": {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 129,
          column: 7
        }
      },
      "57": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 42
        }
      },
      "58": {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 130,
          column: 39
        }
      },
      "59": {
        start: {
          line: 134,
          column: 27
        },
        end: {
          line: 134,
          column: 37
        }
      },
      "60": {
        start: {
          line: 135,
          column: 6
        },
        end: {
          line: 137,
          column: 118
        }
      },
      "61": {
        start: {
          line: 136,
          column: 8
        },
        end: {
          line: 136,
          column: 50
        }
      },
      "62": {
        start: {
          line: 137,
          column: 13
        },
        end: {
          line: 137,
          column: 118
        }
      },
      "63": {
        start: {
          line: 137,
          column: 68
        },
        end: {
          line: 137,
          column: 118
        }
      },
      "64": {
        start: {
          line: 141,
          column: 24
        },
        end: {
          line: 141,
          column: 34
        }
      },
      "65": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 143,
          column: 112
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 16
          },
          end: {
            line: 17,
            column: 17
          }
        },
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 145,
            column: 3
          }
        },
        line: 18
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        loc: {
          start: {
            line: 19,
            column: 53
          },
          end: {
            line: 26,
            column: 5
          }
        },
        line: 19
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 28,
            column: 5
          }
        },
        loc: {
          start: {
            line: 28,
            column: 24
          },
          end: {
            line: 30,
            column: 5
          }
        },
        line: 28
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 32,
            column: 5
          }
        },
        loc: {
          start: {
            line: 32,
            column: 92
          },
          end: {
            line: 35,
            column: 5
          }
        },
        line: 32
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        loc: {
          start: {
            line: 37,
            column: 61
          },
          end: {
            line: 42,
            column: 5
          }
        },
        line: 37
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 44,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        loc: {
          start: {
            line: 44,
            column: 17
          },
          end: {
            line: 47,
            column: 5
          }
        },
        line: 44
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 49,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        loc: {
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 64,
            column: 5
          }
        },
        line: 49
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        loc: {
          start: {
            line: 66,
            column: 22
          },
          end: {
            line: 74,
            column: 5
          }
        },
        line: 66
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 72,
            column: 32
          },
          end: {
            line: 72,
            column: 33
          }
        },
        loc: {
          start: {
            line: 72,
            column: 37
          },
          end: {
            line: 72,
            column: 38
          }
        },
        line: 72
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 76,
            column: 4
          },
          end: {
            line: 76,
            column: 5
          }
        },
        loc: {
          start: {
            line: 76,
            column: 45
          },
          end: {
            line: 122,
            column: 5
          }
        },
        line: 76
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 97,
            column: 53
          },
          end: {
            line: 97,
            column: 54
          }
        },
        loc: {
          start: {
            line: 97,
            column: 58
          },
          end: {
            line: 104,
            column: 7
          }
        },
        line: 97
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 124,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        },
        loc: {
          start: {
            line: 124,
            column: 99
          },
          end: {
            line: 131,
            column: 5
          }
        },
        line: 124
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 133,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        },
        loc: {
          start: {
            line: 133,
            column: 17
          },
          end: {
            line: 138,
            column: 5
          }
        },
        line: 133
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        },
        loc: {
          start: {
            line: 140,
            column: 13
          },
          end: {
            line: 144,
            column: 5
          }
        },
        line: 140
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 107
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 15
          },
          end: {
            line: 34,
            column: 59
          }
        }, {
          start: {
            line: 34,
            column: 63
          },
          end: {
            line: 34,
            column: 107
          }
        }],
        line: 34
      },
      "1": {
        loc: {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }, {
          start: {
            line: 39,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        }],
        line: 39
      },
      "2": {
        loc: {
          start: {
            line: 39,
            column: 10
          },
          end: {
            line: 39,
            column: 89
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 39,
            column: 10
          },
          end: {
            line: 39,
            column: 47
          }
        }, {
          start: {
            line: 39,
            column: 51
          },
          end: {
            line: 39,
            column: 89
          }
        }],
        line: 39
      },
      "3": {
        loc: {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 31
          }
        }, {
          start: {
            line: 51,
            column: 6
          },
          end: {
            line: 51,
            column: 31
          }
        }],
        line: 51
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 54,
            column: 38
          }
        }, {
          start: {
            line: 55,
            column: 8
          },
          end: {
            line: 56,
            column: 26
          }
        }, {
          start: {
            line: 57,
            column: 8
          },
          end: {
            line: 58,
            column: 27
          }
        }, {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 60,
            column: 26
          }
        }, {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 62,
            column: 29
          }
        }],
        line: 52
      },
      "5": {
        loc: {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 41
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 41
          }
        }, {
          start: {
            line: 67,
            column: 6
          },
          end: {
            line: 67,
            column: 41
          }
        }],
        line: 67
      },
      "6": {
        loc: {
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 72,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 24
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 31
          }
        }, {
          start: {
            line: 71,
            column: 8
          },
          end: {
            line: 71,
            column: 39
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 72,
            column: 52
          }
        }],
        line: 69
      },
      "7": {
        loc: {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 78,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 78
      },
      "8": {
        loc: {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }, {
          start: {
            line: 84,
            column: 6
          },
          end: {
            line: 93,
            column: 7
          }
        }],
        line: 84
      },
      "9": {
        loc: {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 91,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 91,
            column: 82
          }
        }, {
          start: {
            line: 90,
            column: 8
          },
          end: {
            line: 91,
            column: 82
          }
        }],
        line: 90
      },
      "10": {
        loc: {
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 90,
            column: 12
          },
          end: {
            line: 90,
            column: 30
          }
        }, {
          start: {
            line: 90,
            column: 34
          },
          end: {
            line: 90,
            column: 42
          }
        }],
        line: 90
      },
      "11": {
        loc: {
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 82
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 82
          }
        }, {
          start: {
            line: 91,
            column: 13
          },
          end: {
            line: 91,
            column: 82
          }
        }],
        line: 91
      },
      "12": {
        loc: {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 32
          }
        }, {
          start: {
            line: 98,
            column: 8
          },
          end: {
            line: 98,
            column: 32
          }
        }],
        line: 98
      },
      "13": {
        loc: {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: 106,
            column: 6
          },
          end: {
            line: 112,
            column: 7
          }
        }],
        line: 106
      },
      "14": {
        loc: {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 53
          }
        }, {
          start: {
            line: 107,
            column: 8
          },
          end: {
            line: 107,
            column: 53
          }
        }],
        line: 107
      },
      "15": {
        loc: {
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 112,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 112,
            column: 7
          }
        }, {
          start: {
            line: 108,
            column: 13
          },
          end: {
            line: 112,
            column: 7
          }
        }],
        line: 108
      },
      "16": {
        loc: {
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }, {
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 119,
            column: 7
          }
        }],
        line: 114
      },
      "17": {
        loc: {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        }, {
          start: {
            line: 127,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        }],
        line: 127
      },
      "18": {
        loc: {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 118
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 118
          }
        }, {
          start: {
            line: 135,
            column: 6
          },
          end: {
            line: 137,
            column: 118
          }
        }],
        line: 135
      },
      "19": {
        loc: {
          start: {
            line: 137,
            column: 13
          },
          end: {
            line: 137,
            column: 118
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 13
          },
          end: {
            line: 137,
            column: 118
          }
        }, {
          start: {
            line: 137,
            column: 13
          },
          end: {
            line: 137,
            column: 118
          }
        }],
        line: 137
      },
      "20": {
        loc: {
          start: {
            line: 137,
            column: 17
          },
          end: {
            line: 137,
            column: 66
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 17
          },
          end: {
            line: 137,
            column: 54
          }
        }, {
          start: {
            line: 137,
            column: 58
          },
          end: {
            line: 137,
            column: 66
          }
        }],
        line: 137
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0, 0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/value.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import shallowEqual from '../utils/shallowEqual';
import utils from './utils';
import { getLocale } from '../locale';
export default (function (Origin) {
  cov_1oajzq6r1v.f[0]++;
  cov_1oajzq6r1v.s[0]++;
  return (
    /*#__PURE__*/
    function (_Component) {
      _inherits(DatePickerValue, _Component);

      var _super = _createSuper2(DatePickerValue);

      function DatePickerValue(props) {
        var _this;

        _classCallCheck(this, DatePickerValue);

        cov_1oajzq6r1v.f[1]++;
        cov_1oajzq6r1v.s[1]++;
        _this = _super.call(this, props);
        cov_1oajzq6r1v.s[2]++;
        _this.state = {
          value: props.value
        };
        cov_1oajzq6r1v.s[3]++;
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
        cov_1oajzq6r1v.s[4]++;
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        cov_1oajzq6r1v.s[5]++;
        _this.rangeWithSingle = _this.rangeWithSingle.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(DatePickerValue, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          cov_1oajzq6r1v.f[2]++;
          cov_1oajzq6r1v.s[6]++;
          this.convertValue(this.props.value);
        }
      }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
          cov_1oajzq6r1v.f[3]++;
          var options = (cov_1oajzq6r1v.s[7]++, {
            deep: ['defaultValue', 'name', 'value']
          });
          cov_1oajzq6r1v.s[8]++;
          return !((cov_1oajzq6r1v.b[0][0]++, shallowEqual(nextProps, this.props, options)) && (cov_1oajzq6r1v.b[0][1]++, shallowEqual(nextState, this.state, options)));
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          cov_1oajzq6r1v.f[4]++;

          var _ref = (cov_1oajzq6r1v.s[9]++, this.props),
              value = _ref.value;

          cov_1oajzq6r1v.s[10]++;

          if ((cov_1oajzq6r1v.b[2][0]++, !shallowEqual(prevProps.value, value)) && (cov_1oajzq6r1v.b[2][1]++, !shallowEqual(value, this.state.value))) {
            cov_1oajzq6r1v.b[1][0]++;
            cov_1oajzq6r1v.s[11]++;
            this.convertValue(value);
          } else {
            cov_1oajzq6r1v.b[1][1]++;
          }
        }
      }, {
        key: "getOptions",
        value: function getOptions() {
          cov_1oajzq6r1v.f[5]++;

          var _ref2 = (cov_1oajzq6r1v.s[12]++, this.props),
              timeZone = _ref2.timeZone;

          cov_1oajzq6r1v.s[13]++;
          return {
            timeZone: timeZone,
            weekStartsOn: getLocale('startOfWeek')
          };
        }
      }, {
        key: "getFormat",
        value: function getFormat() {
          cov_1oajzq6r1v.f[6]++;

          var _ref3 = (cov_1oajzq6r1v.s[14]++, this.props),
              format = _ref3.format,
              type = _ref3.type;

          cov_1oajzq6r1v.s[15]++;

          if (format) {
            cov_1oajzq6r1v.b[3][0]++;
            cov_1oajzq6r1v.s[16]++;
            return format;
          } else {
            cov_1oajzq6r1v.b[3][1]++;
          }

          cov_1oajzq6r1v.s[17]++;

          switch (type) {
            case 'datetime':
              cov_1oajzq6r1v.b[4][0]++;
              cov_1oajzq6r1v.s[18]++;
              return 'YYYY-MM-DD HH:mm:ss';

            case 'month':
              cov_1oajzq6r1v.b[4][1]++;
              cov_1oajzq6r1v.s[19]++;
              return 'YYYY-MM';

            case 'time':
              cov_1oajzq6r1v.b[4][2]++;
              cov_1oajzq6r1v.s[20]++;
              return 'HH:mm:ss';

            case 'week':
              cov_1oajzq6r1v.b[4][3]++;
              cov_1oajzq6r1v.s[21]++;
              return 'GGGG WW';

            default:
              cov_1oajzq6r1v.b[4][4]++;
              cov_1oajzq6r1v.s[22]++;
              return 'YYYY-MM-DD';
          }
        }
      }, {
        key: "rangeWithSingle",
        value: function rangeWithSingle() {
          cov_1oajzq6r1v.f[7]++;
          cov_1oajzq6r1v.s[23]++;

          if (!this.state.value) {
            cov_1oajzq6r1v.b[5][0]++;
            cov_1oajzq6r1v.s[24]++;
            return false;
          } else {
            cov_1oajzq6r1v.b[5][1]++;
          }

          cov_1oajzq6r1v.s[25]++;
          return (cov_1oajzq6r1v.b[6][0]++, this.props.range) && (cov_1oajzq6r1v.b[6][1]++, !this.props.allowSingle) && (cov_1oajzq6r1v.b[6][2]++, Array.isArray(this.state.value)) && (cov_1oajzq6r1v.b[6][3]++, this.state.value.filter(function (v) {
            cov_1oajzq6r1v.f[8]++;
            cov_1oajzq6r1v.s[26]++;
            return v;
          }).length === 1);
        }
      }, {
        key: "convertValue",
        value: function convertValue(value) {
          var _this2 = this;

          cov_1oajzq6r1v.f[9]++;

          var _ref4 = (cov_1oajzq6r1v.s[27]++, this.props),
              range = _ref4.range,
              onChange = _ref4.onChange;

          cov_1oajzq6r1v.s[28]++;

          if (!value) {
            cov_1oajzq6r1v.b[7][0]++;
            cov_1oajzq6r1v.s[29]++;
            this.setState({
              value: value
            });
            cov_1oajzq6r1v.s[30]++;
            return undefined;
          } else {
            cov_1oajzq6r1v.b[7][1]++;
          }

          var format = (cov_1oajzq6r1v.s[31]++, this.getFormat());
          cov_1oajzq6r1v.s[32]++;

          if (!range) {
            cov_1oajzq6r1v.b[8][0]++;

            var _newValue = (cov_1oajzq6r1v.s[33]++, utils.format(utils.toDateWithFormat(value, format, undefined, this.getOptions()), format, this.getOptions()));

            cov_1oajzq6r1v.s[34]++;

            if ((cov_1oajzq6r1v.b[10][0]++, _newValue !== value) && (cov_1oajzq6r1v.b[10][1]++, onChange)) {
              cov_1oajzq6r1v.b[9][0]++;
              cov_1oajzq6r1v.s[35]++;
              onChange(_newValue);
            } else {
              cov_1oajzq6r1v.b[9][1]++;
              cov_1oajzq6r1v.s[36]++;

              if (_newValue !== this.state.value) {
                cov_1oajzq6r1v.b[11][0]++;
                cov_1oajzq6r1v.s[37]++;
                this.setState({
                  value: _newValue
                });
              } else {
                cov_1oajzq6r1v.b[11][1]++;
              }
            }

            cov_1oajzq6r1v.s[38]++;
            return _newValue;
          } else {
            cov_1oajzq6r1v.b[8][1]++;
          } // expand


          var _ref5 = (cov_1oajzq6r1v.s[39]++, this.state),
              quickSelect = _ref5.quickSelect;

          var newValue = (cov_1oajzq6r1v.s[40]++, value.map(function (v) {
            cov_1oajzq6r1v.f[10]++;
            cov_1oajzq6r1v.s[41]++;

            if (!v) {
              cov_1oajzq6r1v.b[12][0]++;
              cov_1oajzq6r1v.s[42]++;
              return undefined;
            } else {
              cov_1oajzq6r1v.b[12][1]++;
            }

            cov_1oajzq6r1v.s[43]++;
            return utils.format(utils.toDateWithFormat(v, format, undefined, _this2.getOptions()), format, _this2.getOptions());
          }));
          cov_1oajzq6r1v.s[44]++;

          if (!shallowEqual(newValue, value)) {
            cov_1oajzq6r1v.b[13][0]++;
            cov_1oajzq6r1v.s[45]++;

            if (onChange) {
              cov_1oajzq6r1v.b[14][0]++;
              cov_1oajzq6r1v.s[46]++;
              onChange(newValue, quickSelect);
            } else {
              cov_1oajzq6r1v.b[14][1]++;
            }
          } else {
            cov_1oajzq6r1v.b[13][1]++;
            cov_1oajzq6r1v.s[47]++;

            if (!shallowEqual(newValue, this.state.value)) {
              cov_1oajzq6r1v.b[15][0]++;
              cov_1oajzq6r1v.s[48]++;
              // reset quickSelect if newValue !== this.state.value
              this.setState({
                value: newValue,
                quickSelect: null
              });
              cov_1oajzq6r1v.s[49]++;
              return newValue;
            } else {
              cov_1oajzq6r1v.b[15][1]++;
            }
          }

          cov_1oajzq6r1v.s[50]++;

          if (shallowEqual(newValue, [undefined, undefined])) {
            cov_1oajzq6r1v.b[16][0]++;
            cov_1oajzq6r1v.s[51]++;
            this.setState({
              value: newValue,
              quickSelect: null
            });
          } else {
            cov_1oajzq6r1v.b[16][1]++;
            cov_1oajzq6r1v.s[52]++;
            // @ts-ignore
            this.state.value = newValue;
          }

          cov_1oajzq6r1v.s[53]++;
          return newValue;
        }
      }, {
        key: "handleChange",
        value: function handleChange(value, callback, quickSelect) {
          cov_1oajzq6r1v.f[11]++;

          var _ref6 = (cov_1oajzq6r1v.s[54]++, this.props),
              range = _ref6.range;

          var newState = (cov_1oajzq6r1v.s[55]++, {
            value: value
          });
          cov_1oajzq6r1v.s[56]++;

          if (range) {
            cov_1oajzq6r1v.b[17][0]++;
            cov_1oajzq6r1v.s[57]++;
            newState.quickSelect = quickSelect;
          } else {
            cov_1oajzq6r1v.b[17][1]++;
          }

          cov_1oajzq6r1v.s[58]++;
          this.setState(newState, callback);
        }
      }, {
        key: "handleBlur",
        value: function handleBlur() {
          cov_1oajzq6r1v.f[12]++;

          var _ref7 = (cov_1oajzq6r1v.s[59]++, this.props),
              onChange = _ref7.onChange;

          cov_1oajzq6r1v.s[60]++;

          if (this.rangeWithSingle()) {
            cov_1oajzq6r1v.b[18][0]++;
            cov_1oajzq6r1v.s[61]++;
            this.setState({
              value: this.props.value
            });
          } else {
            cov_1oajzq6r1v.b[18][1]++;
            cov_1oajzq6r1v.s[62]++;

            if ((cov_1oajzq6r1v.b[20][0]++, this.state.value !== this.props.value) && (cov_1oajzq6r1v.b[20][1]++, onChange)) {
              cov_1oajzq6r1v.b[19][0]++;
              cov_1oajzq6r1v.s[63]++;
              onChange(this.state.value, this.state.quickSelect);
            } else {
              cov_1oajzq6r1v.b[19][1]++;
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          cov_1oajzq6r1v.f[13]++;

          var _ref8 = (cov_1oajzq6r1v.s[64]++, this.state),
              value = _ref8.value;

          cov_1oajzq6r1v.s[65]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              onChange: this.handleChange,
              onValueBlur: this.handleBlur,
              value: value,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 143,
                columnNumber: 14
              }
            }))
          );
        }
      }]);

      return DatePickerValue;
    }(Component)
  );
});